var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.176 1.75H4.824L1.75 4.824v4.352l3.074 3.074h4.352l3.074-3.074V4.824L9.176 1.75zm1.907 6.942l-2.391 2.391H5.308L2.917 8.692V5.308l2.391-2.391h3.384l2.391 2.391v3.384z",
    fill: "#E11900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.917A.583.583 0 107 8.75a.583.583 0 000 1.167zM6.417 4.083h1.166v4.084H6.417V4.083z",
    fill: "#E11900"
  })));
}
export default SvgReport;